/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resumes_Docx_Export_FailedInputs */

const en_resumes_docx_export_failed = /** @type {(inputs: Resumes_Docx_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DOCX export failed.`)
};

const de_resumes_docx_export_failed = /** @type {(inputs: Resumes_Docx_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DOCX-Export fehlgeschlagen.`)
};

const fr_resumes_docx_export_failed = /** @type {(inputs: Resumes_Docx_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de l'export DOCX.`)
};

const es_resumes_docx_export_failed = /** @type {(inputs: Resumes_Docx_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error en la exportación DOCX.`)
};

const it_resumes_docx_export_failed = /** @type {(inputs: Resumes_Docx_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione DOCX non riuscita.`)
};

const nl_resumes_docx_export_failed = /** @type {(inputs: Resumes_Docx_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DOCX-export mislukt.`)
};

const pl_resumes_docx_export_failed = /** @type {(inputs: Resumes_Docx_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eksport DOCX nie powiódł się.`)
};

const fi_resumes_docx_export_failed = /** @type {(inputs: Resumes_Docx_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DOCX-vienti epäonnistui.`)
};

const da_resumes_docx_export_failed = /** @type {(inputs: Resumes_Docx_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DOCX-eksport mislykkedes.`)
};

const sv_resumes_docx_export_failed = /** @type {(inputs: Resumes_Docx_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DOCX-export misslyckades.`)
};

/**
* | output |
* | --- |
* | "DOCX export failed." |
*
* @param {Resumes_Docx_Export_FailedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resumes_docx_export_failed = /** @type {((inputs?: Resumes_Docx_Export_FailedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resumes_Docx_Export_FailedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resumes_docx_export_failed(inputs)
	if (locale === "fr") return fr_resumes_docx_export_failed(inputs)
	if (locale === "es") return es_resumes_docx_export_failed(inputs)
	if (locale === "it") return it_resumes_docx_export_failed(inputs)
	if (locale === "nl") return nl_resumes_docx_export_failed(inputs)
	if (locale === "pl") return pl_resumes_docx_export_failed(inputs)
	if (locale === "fi") return fi_resumes_docx_export_failed(inputs)
	if (locale === "da") return da_resumes_docx_export_failed(inputs)
	if (locale === "sv") return sv_resumes_docx_export_failed(inputs)
	return en_resumes_docx_export_failed(inputs)
});